export default __webpack_public_path__ + "static/media/bg8.07fdf3d3.jpg";